import '../../../styles/index.css'
import './CardMaisPrecos.css';
import CustomButton from '../../Buttons/CustomButton/CustomButton';
import ExternalButton from '../../../assets/icons/External Page Icon Branco.svg'
import Preço from '../../Preços/Preço/Preço';
import OfertadoPor from './OfertadoPor/OfertadoPor';

function CardMaisPrecos({ imagem, preço, preçoParcelado, loja, link }) {

  return (

    <>

      <div className='cardMaisPrecosMobile cardMaisPrecos container shadow'>

        <div className='h-100 d-flex flex-column justify-content-evenly'>
          <img className='imagemCardMaisPrecos' src={imagem} alt="Produto" data-cy="card-mais-precos-imagem"/>

          <a href={link} data-cy="card-mais-precos-link">
            <CustomButton icone={ExternalButton} texto='Ver Oferta' cor='#A80A01' tipo='1' />
          </a>
        </div>

        <div className='h-100 d-flex flex-column justify-content-evenly'>
          <div className='text-end'>
            <Preço preço={preço} preçoParcelado={preçoParcelado} />
          </div>

          <OfertadoPor loja={loja} />
        </div>

      </div>

      <div className='cardMaisPrecosDesktop cardMaisPrecos px-4 shadow'>

        <div className='d-flex gap-4 align-items-center'>
          <img className='imagemCardMaisPrecos' src={imagem} alt="Produto"  data-cy="card-mais-precos-imagem"/>

          <div>
            <Preço preço={preço} preçoParcelado={preçoParcelado} />
          </div>
        </div>

        <div className='d-flex gap-4 align-items-center'>
          <a href={link} data-cy="card-mais-precos-link">
            <CustomButton icone={ExternalButton} texto='Ver Oferta' cor='#A80A01' tipo='1' />
          </a>

          <OfertadoPor loja={loja} />
        </div>

      </div>

    </>

  );
}

export default CardMaisPrecos;
